import React, { CSSProperties } from 'react';
import mapVOPStatusToDisplay from 'components/Payments/VOP/mapVOPStatusToDisplay';
import t from 'utils/translationHelper';

import { APTooltip } from '@alpha/ui-lib/ui/Tooltip/APTooltip';

import { IVOPCheckTooltipProps } from './VOPCheckTooltip.interfaces';

const VOPCheckTooltip: React.FC<IVOPCheckTooltipProps> = ({
  vopCheck,
  children,
  vopAccepted,
}) => {
  const vopStatus = mapVOPStatusToDisplay(vopCheck);

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      padding: '8px',
    },
    verificationCheck: {
      filter: 'drop-shadow(0 0 2px rgba(0, 0, 0, 0.2))',
      color: 'rgba(255, 255, 255, 1)',
      lineHeight: '20px',
      fontWeight: '700',
      fontSize: '13px',
      fontFamily: 'Source Sans Pro',
      textAlign: 'left',
      marginBottom: '8px',
    },
    verificationStatus: {
      filter: 'drop-shadow(0 0 2px rgba(0, 0, 0, 0.2))',
      color: 'rgba(255, 255, 255, 1)',
      lineHeight: '20px',
      fontWeight: '400',
      fontSize: '13px',
      fontFamily: 'Source Sans Pro',
      textAlign: 'left',
      marginBottom: '16px',
    },
    clickToViewFullResponse: {
      filter: 'drop-shadow(0 0 2px rgba(0, 0, 0, 0.2))',
      color: 'rgba(30, 135, 119, 1)',
      lineHeight: '20px',
      fontWeight: '400',
      fontSize: '13px',
      fontFamily: 'Source Sans Pro',
      textAlign: 'left',
      margin: '12px 12px 6px 0px',
    },
  } as unknown as Record<string, CSSProperties>;

  const vopAcceptedText = vopAccepted ? t('verification_accepted') : t('verification_pending');

  const tooltipContent = (
    <div style={styles.container}>
      <div style={styles.verificationCheck}>{vopAcceptedText}</div>
      <div style={styles.verificationStatus}>{t(vopStatus)}</div>
      <div style={styles.clickToViewFullResponse}>
        {' '}
        {t('click_to_view_full_response')}
        {' '}
      </div>
    </div>
  );

  return (
    <APTooltip title={tooltipContent} padding='8px'>
      <span>{children || t('hover_to_see_details')}</span>
    </APTooltip>
  );
};

export default VOPCheckTooltip;
